import { NUMBER_1, NUMBER_2 } from "~shared/constants";

export const UTM_SOURCE_NOT_DEFINED = 'undefined utm_source';

export enum MarketingFeedQueryParams {
  OfferID = 'mfeed_oid',
  UtmSource = 'utm_source',
  BusinessModel = 'mfeed_bm'
}

export enum MFeedBusinessModel {
  B2C = NUMBER_1,
  B2B = NUMBER_2
}
